import { m as matchContractVariables } from "./TipTapEditor.js";
import { a as allUnits } from "./unit.js";
import { t as tariffs } from "./tariffs.js";
import { TemplateHandler } from "easy-template-x";
import { a as PUBLIC_API_PATH } from "./public.js";
import { w as writable } from "./index2.js";
import { S as Sleep } from "./sleep.js";
const handler = new TemplateHandler({
  /*scopeDataResolver: createResolver({
      angularFilters: {
          toTextLimited: (value: boolean) => value ? 'befristet': 'unbefristet'
      }
  }),*/
  delimiters: {
    tagStart: "${",
    tagEnd: "}",
    containerTagOpen: ">>",
    containerTagClose: "<<"
  }
});
async function wordDocumentParser(url, data) {
  const response = await fetch(url, {
    headers: {
      Authorization: "Bearer " + localStorage.getItem("token")
    }
  });
  const templateFile = await response.blob();
  return await handler.process(templateFile, data);
}
const templateDocuments = writable([]);
let units = [];
let localTariffs = [];
let localTemplates = [];
allUnits.subscribe((x) => units = x);
tariffs.subscribe((x) => localTariffs = x);
templateDocuments.subscribe((x) => localTemplates = x);
async function generateContractPreview(employee, contract, contractHistory, customVariables) {
  await Sleep(100);
  const documentTemplateId = localTemplates.find((x) => x.contractType === contract?.contractType)?.id;
  return await parsePreview(employee, contract, contractHistory, customVariables, documentTemplateId);
}
const parsePreview = async (employee, contract, contractHistory, customVariables, documentTemplateId) => {
  const variables = matchContractVariables(
    {
      ...employee,
      unit: units.find((u) => u.id === employee.unitId)
    },
    contract,
    contractHistory,
    localTariffs,
    customVariables
  );
  return await wordDocumentParser(PUBLIC_API_PATH + "/template-document/" + documentTemplateId + "/binary", variables);
};
export {
  generateContractPreview as g,
  templateDocuments as t
};
//# sourceMappingURL=generateContractPreview.js.map
